import get from "lodash/get";
import * as APIS from "../../../constants/api";

export const fetchAllOrganizationsContacts =
  (id, payload) => (dispatch, getState, api) => {
    const url = `${APIS.BASE_ORGANIZATION}/${id}${APIS.FETCH_ALL_ORGANIZATIONS_CONTACTS}`;
    return api
      .post(url, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

export const fetchSingleOrganizationsContacts =
  (payload) => (dispatch, getState, api) => {
    const url = `${APIS.BASE_ORGANIZATION}/${get(
      payload,
      "organization_id",
      0
    )}/contact/${get(payload, "id", 0)}`;
    return api
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
export const createOrganizationsContact =
  (payload) => (dispatch, getState, api) => {
    const url = `${APIS.BASE_ORGANIZATION}/${get(payload, "did", 0)}${
      APIS.CREATE_ORGANIZATION_CONTACT
    }`;
    return api
      .post(url, {
        org_contact_type_id: get(payload, "org_contact_type_id", 0),
        name: get(payload, "name", ""),
        phone: get(payload, "phone", 0),
        email: get(payload, "email", ""),
      })
      .then(() => {})
      .catch((error) => {
        throw error;
      });
  };

export const deleteOrganizationContact =
  (payload) => (dispatch, getState, api) => {
    const url = `${APIS.BASE_ORGANIZATION}/${get(
      payload,
      "organization_id",
      0
    )}/contact/${get(payload, "id", 0)}`;
    return api
      .delete(url)
      .then(() => {})
      .catch((error) => {
        throw error;
      });
  };

export const updateOrganizationsContact =
  (payload) => (dispatch, getState, api) => {
    const url = `${APIS.BASE_ORGANIZATION}/${get(
      payload,
      "did",
      0
    )}/contact/${get(payload, "cid", 0)}`;
    return api
      .patch(url, {
        org_contact_type_id: get(payload, "org_contact_type_id", 0),
        name: get(payload, "name", ""),
        phone: get(payload, "phone", 0),
        email: get(payload, "email", ""),
      })
      .then(() => {})
      .catch((error) => {
        throw error;
      });
  };
export const fetchContactType = () => (dispatch, getState, api) => {
  const url = `${APIS.FETCH_ORGANIZATION_CONTACT_TYPE}`;
  return api
    .get(url)
    .then((result) => result)
    .catch((error) => {
      throw error;
    });
};
